/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amorim API v1
 * Amorim API v1 — Public-facing endpoints (CMS, authentication, authenticated user resources, reservations).
 *
 * **Authentication**
 *
 * - All requests require an `Api-Key` header.
 * - Endpoints that operate on the authenticated user additionally require `Authorization: Bearer <jwt>`.
 * OpenAPI spec version: v1
 */
import type {
  ActivityDetailDto,
  ActivityFeedDto,
  ActivityListItemDtoPagedResult,
  GetMeActivityCurrentV1Params,
  GetMeActivityPastV1Params
} from '../model';

import { customFetch } from '../../../custom-fetch.ts';

export type getMeActivityByIdV1Response200 = {
  data: ActivityDetailDto
  status: 200
}

export type getMeActivityByIdV1Response401 = {
  data: void
  status: 401
}

export type getMeActivityByIdV1Response404 = {
  data: void
  status: 404
}

export type getMeActivityByIdV1ResponseSuccess = (getMeActivityByIdV1Response200) & {
  headers: Headers;
};
export type getMeActivityByIdV1ResponseError = (getMeActivityByIdV1Response401 | getMeActivityByIdV1Response404) & {
  headers: Headers;
};

export type getMeActivityByIdV1Response = (getMeActivityByIdV1ResponseSuccess | getMeActivityByIdV1ResponseError)

export const getGetMeActivityByIdV1Url = (id: string,) => {




  return `/api/v1/me/activity/${id}`
}

/**
 * Returns a typed envelope whose populated branch (order or reservation) is resolved by the backend from the id — no client-supplied type. User can only access their own activity.
 * @summary Get a single activity detail (order or reservation)
 */
export const getMeActivityByIdV1 = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<getMeActivityByIdV1Response> => {

  return customFetch<getMeActivityByIdV1Response>(getGetMeActivityByIdV1Url(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type getMeActivityCurrentV1Response200 = {
  data: ActivityListItemDtoPagedResult
  status: 200
}

export type getMeActivityCurrentV1Response401 = {
  data: void
  status: 401
}

export type getMeActivityCurrentV1ResponseSuccess = (getMeActivityCurrentV1Response200) & {
  headers: Headers;
};
export type getMeActivityCurrentV1ResponseError = (getMeActivityCurrentV1Response401) & {
  headers: Headers;
};

export type getMeActivityCurrentV1Response = (getMeActivityCurrentV1ResponseSuccess | getMeActivityCurrentV1ResponseError)

export const getGetMeActivityCurrentV1Url = (params?: GetMeActivityCurrentV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/me/activity/current?${stringifiedParams}` : `/api/v1/me/activity/current`
}

/**
 * Returns the active shop (Fashion) orders for the authenticated user — the CURRENT tab.
 * Bookings never appear here. Offset-paginated.
 *
 * Query Parameters:
 * - page: Page number (default: 1)
 * - pageSize: Items per page (default: 20, max: 100)
 * @summary Get the CURRENT activity tab (active shop orders)
 */
export const getMeActivityCurrentV1 = async (params?: GetMeActivityCurrentV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getMeActivityCurrentV1Response> => {

  return customFetch<getMeActivityCurrentV1Response>(getGetMeActivityCurrentV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type getMeActivityPastV1Response200 = {
  data: ActivityFeedDto
  status: 200
}

export type getMeActivityPastV1Response401 = {
  data: void
  status: 401
}

export type getMeActivityPastV1ResponseSuccess = (getMeActivityPastV1Response200) & {
  headers: Headers;
};
export type getMeActivityPastV1ResponseError = (getMeActivityPastV1Response401) & {
  headers: Headers;
};

export type getMeActivityPastV1Response = (getMeActivityPastV1ResponseSuccess | getMeActivityPastV1ResponseError)

export const getGetMeActivityPastV1Url = (params?: GetMeActivityPastV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/me/activity/past?${stringifiedParams}` : `/api/v1/me/activity/past`
}

/**
 * Returns the chronological PAST feed — finished standalone orders merged with finished
 * reservations, most recent first. Date-cursor paginated: pass the previous response's nextCursor as `before`.
 *
 * Query Parameters:
 * - before: ISO-8601 cursor; returns items on/before this date (omit for the first page)
 * - limit: Items to return (default: 20, max: 100)
 * @summary Get the PAST activity feed (finished orders + reservations)
 */
export const getMeActivityPastV1 = async (params?: GetMeActivityPastV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getMeActivityPastV1Response> => {

  return customFetch<getMeActivityPastV1Response>(getGetMeActivityPastV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}


